import { prefix } from "../../design-tokens/meta";
import { events } from "../../js/state-machine";
import { matchers } from "../../js/validate-props";
import { positions } from "../../js/positioning";

export const componentName = "Popover";

export const eventMap = {
    opened: events.opened(componentName),
    closed: events.closed(componentName),
};

// Sizes have 16 pixels added to account for a possible gutter on left and right.
export const sizes = {
    sm: 288,
    md: 488,
    lg: 800,
};

export const defaultProps = {
    placement: positions.top,
    size: "sm",
    srCloseLabel: "close popover",
};

export const schema = Object.freeze({
    trigger: matchers.minChars(1),
    srCloseLabel: matchers.minChars(1),
    placement: matchers.match(/(left|right|top|bottom)+(-start|-end)*/gi),
});

export const componentClasses = {
    popover: {
        basic: `${prefix}popover`,
        md: `${prefix}popover--md`,
        lg: `${prefix}popover--lg`,
    },
    open: `${prefix}popover--open`,
    content: `${prefix}popover__content`,
    body: `${prefix}popover__body`,
    header: `${prefix}popover__header`,
    headline: `${prefix}popover__headline`,
    animating: `${prefix}popover--animating`,
    close: `${prefix}popover__close`,
    pointer: `${prefix}popover__pointer`,
};

export const views = {
    open: {
        classList: [`${componentClasses.open}`],
    },
    close: {
        classList: [`!${componentClasses.open}`],
    },
    beforeAnimation: {
        classList: [`${componentClasses.animating}`],
    },
    afterAnimation: {
        classList: [`!${componentClasses.animating}`],
    },
    sizes: {
        sm: {
            classList: [`!${componentClasses.popover.md}`, `!${componentClasses.popover.lg}`],
        },
        md: {
            classList: [componentClasses.popover.md, `!${componentClasses.popover.lg}`],
        },
        lg: {
            classList: [`!${componentClasses.popover.md}`, componentClasses.popover.lg],
        },
    },
};
